export function emailToName(email?: string | null): string {
  if (!email) return '';
  const match = new RegExp(/^([a-z]+)_([a-z]+)@shi\.com$/i).exec(email);
  if (!match) return email;
  const [_, first, last] = match;
  return `${first.charAt(0).toUpperCase()}${first.slice(1)} ${last.charAt(0).toUpperCase()}${last.slice(1)}`;
}